import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { get } from 'lodash';

// components
import BaseModal from 'common/modals/BaseModal';
import ModalTextInput from 'common/modals/ModalTextInput';

const baseString = 'vra-rename-modal';
let RenameModal = ({
  onCancelRenameModal,
  onChangeRenameInput,
  onSaveRenameModal,
  renameModal,
  scriptId,
  validationResult
}) => {
  if (!renameModal) {
    return null;
  }

  const { value: defaultRenameScriptName } = renameModal;
  const isInvalid = get(validationResult, 'isInvalid', false);

  return (
    <BaseModal
      header={getMessage('title-text__rename-prescription')}
      isInvalid={isInvalid}
      onCancel={() => { onCancelRenameModal(); }}
      onSave={() => { onSaveRenameModal({ scriptId }); }}
      saveText={getMessage('button-text__save-changes')}
      shouldCloseOnOverlayClick={false}>
      <ModalTextInput
        baseString={baseString}
        defaultValue={defaultRenameScriptName}
        labelText={getMessage('label-text__rx-name')}
        onChange={(e) => { onChangeRenameInput(e.target.value); }}
        validationResult={validationResult}
      />
    </BaseModal>
  );
};

RenameModal.propTypes = {
  onCancelRenameModal: propTypes.func,
  onChangeRenameInput: propTypes.func,
  onSaveRenameModal: propTypes.func,
  renameModal: propTypes.object,
  scriptId: propTypes.string,
  validationResult: propTypes.object
};

export default RenameModal;
